export default from './Alert';



// WEBPACK FOOTER //
// ./src/sharedComponents/Alert/index.js